import http from './http';
import { handleResponse } from '@/shared/utils/promise-helpers';

export const getAll = () => http.get('/tags').then((res) => res.data);

export const store = (tag) => http.post('/tags', tag).then((res) => res.data);

export const addTagToAttendance = ({ tag, protocol }) =>
  http.post(`/tags/protocol/${protocol}`, tag).then(handleResponse);

export const removeTagsFromAttendance = ({ tag, protocol }) =>
  http.delete(`/tags/protocol/${protocol}/${tag.id}`).then(handleResponse);

export const getTagsByProtocol = (protocol) =>
  http.get(`/tags/protocol/${protocol}`).then(handleResponse);
